import { Stats } from "./stats";

export class SeasonStats {
    seasonStart: Date;
    seasonEnd: Date;
    stats: Stats[];
  }
